import { nextIterationAsync } from "./_nextIterationAsync.js";
export const allAsync = (source, predicate) => {
    const nextIter = nextIterationAsync(source, async (x) => {
        if (await predicate(x) === false) {
            throw new Error(String(false));
        }
        return true;
    });
    switch (nextIter.type) {
        case 1:
            return Promise.all(nextIter.generator())
                .then(() => true, () => false);
        case 2:
            return nextIter.generator()
                .then(Promise.all.bind(Promise))
                .then(() => true, () => false);
    }
};
